import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

@NgModule({
    imports: [RouterModule.forChild([        
        { path: '', data: { breadcrumb : '' }, loadChildren: () => import('./tipo-pagamento-listar/tipo-pagamento-listar.module').then(m => m.TipoPagamentoListarModule) },
        { path: 'inserir', data: { breadcrumb : 'Novo' }, loadChildren: () => import('./tipo-pagamento-inserir/tipo-pagamento-inserir.module').then(m => m.TipoPagamentoInserirModule) },
        { path: 'editar', data: { breadcrumb : 'Editar' }, loadChildren: () => import('./tipo-pagamento-editar/tipo-pagamento-editar.module').then(m => m.TipoPagamentoEditarModule) },
        { path: 'detalhar', data: { breadcrumb : 'Detalhar' }, loadChildren: () => import('./tipo-pagamento-detalhar/tipo-pagamento-detalhar.module').then(m => m.TipoPagamentoDetalharModule) }
    ])],
    exports: [RouterModule]
})
export class TipoPagamentoAppRoutingModule { }